// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__9vwel","productName":"Table_productName__CuOtw"};